// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/life-buoy.js';

import { paths } from '../generated/life-buoy';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('life-buoy', Original, paths);
